import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';
import { userInfo } from 'os';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-rendererDocument',
  template: `
  <!-- this condition was on button below *ngIf="params?.data.status == 'Active' && params?.isShowEdit-->
    <button [disabled]="params.data.isEditAllowed != 1"
      mat-mini-fab
      color="primary"
      [title]="t('Edit', 'Edit')"
      (click)="onClick($event)"
    >
      <mat-icon>edit</mat-icon>
    </button>
    <button *ngIf="params?.data.status == 'Draft' && params?.data.disableApproved == true ? true : false"
      mat-mini-fab
      color="accent"
      [title]="t('DraftOptions', 'Draft Options')"
      (click)="onClick($event)"
      [hidden]="hideApprovalLvl"
    >
    <mat-icon>assignment</mat-icon></button>

    <button *ngIf="params?.data.status == 'Draft' && params?.data.disableApproved == true ? true : false"
      mat-mini-fab
      color="accent"
      [title]="t('ApproveReject', 'Approve / Reject')"
      (click)="onClick($event)"
      [disabled]="params.data.disableDraft || this.approveReject"
    >
    <mat-icon>check</mat-icon>
    </button>

    <button *ngIf="params?.data.status == 'Draft' && params?.data.disableApproved == false ? true : false"
    mat-mini-fab
    color="accent"
    [title]="t('DraftOptions', 'Draft Options')"
    (click)="onClick($event)"
    [disabled]="params.data.disableApproved"
  >
  <mat-icon>alarm icon</mat-icon></button>

    <button *ngIf="params?.data.status == 'Inactive' || params?.data.status == 'Rejected'"
      mat-mini-fab
      color="warn"
      [title]="t('DraftOptions', 'Draft Options')"
      (click)="onClick($event)"
    >
    <mat-icon>warning</mat-icon>
    </button>
    <button [hidden]="true"
      mat-mini-fab
      color="accent"
      [title]="t('ViewDocument', 'View Document')"
      (click)="onClick($event)"
    >
      <mat-icon>visibility</mat-icon>
    </button>
    <!--<button
      mat-mini-fab
      color="warn"
      [title]="t('DownloadDocument', 'Download Document')"
      (click)="onClick($event)">
      <mat-icon>download</mat-icon>
    </button>-->

    <button
    mat-mini-fab
    color="primary"
    [title]="t('OpenChat', 'Open Chat')"
    (click)="onClick($event)"
    [disabled]="params.data.disableChat">
    <mat-icon>chat</mat-icon>
  </button>

   <button *ngIf="params.data.status == 'Active'"
    mat-mini-fab
    color="accent"
    [title]="t('OpenCR', 'Open Change Requests')"
    (click)="onClick($event)">
    <div *ngIf="params.data.pendingCRCount > 0" class='crCount' style="position: absolute; top: -2px; right: -5px; background-color: #dc2626; color: white; font-weight: 500; padding: 0.3rem; padding-left: 0.5rem; padding-right: 0.5rem;z-index: 100; font-size: 0.5rem; border-radius: 50%">{{params.data.pendingCRCount}}</div>
    <mat-icon><mat-icon>settings_backup_restore</mat-icon></mat-icon>
  </button>
      <button *ngIf="params.data.status == 'Active' && params.data.isEditAllowed == 1"
      mat-mini-fab
      color="warn"
      style="background-color: #f1b718ff;"
      [title]="t('SetAssignees', 'Set Assignees')"
      (click)="onClick($event)"
    >
      <mat-icon>assignment_turned_in</mat-icon>
    </button>

  <mat-slide-toggle [ngStyle]="getToggleStyle(params)" *ngIf="params.data.isEditAllowed != 0 && (params.data.status =='Active' ? params.isDeActivate : params.isActive)" [title]="t('ActiveInactive', 'Active / Inactive')" [disabled]="params.data.disableActToggle" [checked]="params.data.status =='Active' ?  true : false"></mat-slide-toggle>


  
   
    <!-- <button
      mat-mini-fab
      color="warn"
      style="background-color: #000;"
      [title]="t('DocumentQuestions', 'Document Questions')"
      (click)="onClick($event)"
    >
      <mat-icon>question_answer</mat-icon>
    </button> -->
  
  `,
  styles: [
    `
      button {
        height: 35px;
        width: 35px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 0 3px;
      }
      .mat-icon {
        transform: scale(0.7);
      }
    `,
  ],
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererDocument implements ICellRendererAngularComp {
  public params: any;
  public approveReject:boolean = true;
  public hideApprovalLvl:boolean = false;
  constructor(public translate: TranslateService) {}

  /** langObj (cellRendererParams.getLangObj) -> "Documents.<key>" -> flat key -> English. */
  public t(key: string, fallback: string): string {
    const langObj =
      this.params && typeof this.params.getLangObj === 'function'
        ? this.params.getLangObj()
        : null;
    if (langObj && langObj[key]) {
      return langObj[key];
    }
    for (const candidate of ['Documents.' + key, key]) {
      const value = this.translate.instant(candidate);
      if (typeof value === 'string' && value !== candidate) {
        return value;
      }
      if (value && typeof value === 'object' && typeof value.title === 'string') {
        return value.title;
      }
    }
    return fallback;
  }

  refresh(params: any): boolean {
    //throw new Error('Method not implemented.');
    this.params = params;
    return true;
  }
  public agInit(params: any): void {
    let userdata = JSON.parse(localStorage.logged_in_user);
    let userCode = userdata.userCode;
    this.params = params;
    if(this.params.data.totalLevelApproversEmpId.includes(userCode))
    {
      this.approveReject = false;
    }
    if(params.data.approvalAuthorityPosition === 'owner')
    {
      if(params.data.draftOwner === userCode)
      {
        this.approveReject = false;
      }
      if(params.data.isSuperAdmin === true)
      {
        this.approveReject = false;
      }
      this.hideApprovalLvl  = true;
    }
  } 
  
  onClick($event: any): any {

    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
      };
      this.params.onClick(params);
    }
  }

  getToggleStyle(params: any) {
    return params.data.status === 'Draft' ? { display: 'none' } : {};
  }
}
